import {AcademyBookTypes} from './academy';
import {ICmsItem} from './cms';
import {FormControl} from '@angular/forms';

export enum CmsAcademyBooksSortingModes {
  PublishDate = 'Publish date',
  Title = 'Title',
  NewestFirst = 'Newest First'
}

export enum CmsAcademyBooksCategories {
  Cat1 = 'Cat1',
  Cat2 = 'Cat2',
  Cat3 = 'Cat3'
}

export enum CmsAcademyBooksLanguages {
  Danish = 'Danish',
  English = 'English',
  Polish = 'Polish'
}

export enum CmsAcademyBooksGenries {
  Ebook = 'E-book'
}

export interface IAcademyBookItem extends ICmsItem {
  pages: number;
  cover?: string;
  attachment?: ICmsAcademyBookAttachment;
  type?: AcademyBookTypes;
  language?: string;
  fileTypes: Array<string>;
  publishDate: Date;
  categories: Array<string>;
  genre: string;
  titleOfTheMonth: boolean;
}

export interface ICmsAcademyBookAttachment {
  fileName: string;
  url: string;
  contentType: string;
  details: {
    size: number;
    image: string;
  };
}

export interface IAcademyBooksFilters {
  categories?: Array<string>;
  languages?: Array<string>;
  genre?: CmsAcademyBooksGenries;
  sortingMode?: CmsAcademyBooksSortingModes;
}

export interface IAcademyBooksFiltersForm {
  categories: FormControl<Array<string>>;
  languages: FormControl<Array<string>>;
  genre: FormControl<string>;
}

export interface IAcademyBookOrderDetails {
  BookId: string;
  BookTitle: string;
  BookAuthor: string;
  PublicationDate: Date;
  NumberOfPages: number;
  Language: string;
  FileTypes: string;
}
